















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { TimePicker, TimeSelect } from 'element-ui';
@Component({
  name: 'lb-time-picker'
  // components: {
  //   'el-time-select': TimeSelect,
  //   'el-time-picker': TimePicker
  // }
})
export default class extends Vue {
  @Prop() private value!: any;
  @Prop() private size!: string;
  @Prop() private format!: string;
  @Prop() private valueFormat!: string;
  @Prop({ type: Boolean, default: false }) private readonly!: boolean;
  @Prop() private placeholder!: string;
  @Prop() private startPlaceholder!: string;
  @Prop() private endPlaceholder!: string;
  @Prop() private prefixIcon!: string;
  @Prop({ default: 'el-icon-circle-close' }) private clearIcon!: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ type: Boolean, default: false }) private clearable!: boolean;
  @Prop() private popperClass!: string;
  @Prop({ type: Boolean, default: true }) private editable!: boolean;
  @Prop({ default: 'left' }) private align!: string;
  @Prop() private defaultValue!: any;
  @Prop() private defaultTime!: any;
  @Prop({ default: '-' }) private rangeSeparator!: string;
  @Prop() private pickerOptions!: any;
  @Prop({ type: Boolean, default: false }) private unlinkPanels!: boolean;
  @Prop({ type: Boolean, default: true }) private validateEvent!: boolean;
  @Prop({ default: 'time.ts' }) private type!: string;

  private localValue: any = this.value;
  private inputFocus: boolean = false;

  private handleFocus() {
    this.inputFocus = true;
    this.$emit('focus');
  }
  private handleBlur() {
    this.inputFocus = false;
    this.$emit('blur');
  }

  @Watch('value')
  private onValueChange(date: any) {
    this.localValue = date;
  }

  @Watch('localValue')
  private onLocalValueChange(date: any) {
    this.$emit('input', date);
  }
}
